/**
 * SP FAQ Click Tracking with PostHog
 * Tracks FAQ question clicks and expansions
 */

(function() {
  'use strict';
  
  // Wait for PostHog to be available
  function waitForPostHog(callback, maxAttempts = 50) {
    let attempts = 0;
    
    function checkPostHog() {
      attempts++;
      
      if (typeof window.posthog !== 'undefined') {
        console.log('PostHog found, initializing FAQ tracking');
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkPostHog, 100); // Check every 100ms
      } else {
        console.warn('PostHog not available after', attempts, 'attempts - FAQ tracking disabled');
      }
    }
    
    checkPostHog();
  }
  
  function initFAQTracking() {
    try {
      // Find all FAQ sections
      const faqSections = document.querySelectorAll('.collapsible-tabs');

      if (faqSections.length === 0) {
        console.log('No FAQ sections found on this page - SP FAQ tracking skipped');
        return;
      }

      // Shared function to extract product and collection context from page
      const getProductContext = () => {
        const context = {};

        // Get product handle from URL or meta tags
        const urlMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (urlMatch) {
          context.product_handle = urlMatch[1];
        }

        // Get product ID from meta tags (Shopify standard)
        const productMeta = document.querySelector('meta[name="shopify-product-id"]');
        if (productMeta) {
          context.product_id = productMeta.content;
        }

        // Get collection handles from breadcrumbs or navigation
        const breadcrumbs = document.querySelector('.breadcrumbs');
        if (breadcrumbs) {
          const collectionLinks = breadcrumbs.querySelectorAll('a[href*="/collections/"]');
          if (collectionLinks.length > 0) {
            const lastCollection = collectionLinks[collectionLinks.length - 1];
            const collectionMatch = lastCollection.href.match(/\/collections\/([^\/\?]+)/);
            if (collectionMatch) {
              context.collection_handle = collectionMatch[1];
              context.collection_name = lastCollection.textContent.trim();
            }
          }
        }

        // Fallback: extract from URL if no breadcrumbs
        if (!context.collection_handle) {
          const urlCollectionMatch = document.referrer.match(/\/collections\/([^\/\?]+)/);
          if (urlCollectionMatch) {
            context.collection_handle = urlCollectionMatch[1];
          }
        }

        return context;
      };
    
    faqSections.forEach(section => {
      const sectionTitle = section.querySelector('.collapsible-tabs__heading')?.textContent?.trim() || 'FAQ';
      const faqQuestions = section.querySelectorAll('details.disclosure');
      
      faqQuestions.forEach((details, index) => {
        const summary = details.querySelector('summary.disclosure__title');
        const questionText = summary?.textContent?.trim();
        
        if (!questionText) return;
        
        // Track when FAQ is toggled (opened/closed)
        details.addEventListener('toggle', function() {
          try {
            const isOpen = details.open;

            // Auto-close other FAQ items when this one opens (with smooth animation)
            if (isOpen) {
              faqQuestions.forEach(otherDetails => {
                if (otherDetails !== details && otherDetails.open) {
                  // Trigger the summary click to close smoothly instead of abrupt close
                  const otherSummary = otherDetails.querySelector('summary.disclosure__title');
                  if (otherSummary) {
                    otherSummary.click();
                  }
                }
              });
            }

            console.log('FAQ toggled:', questionText, isOpen ? 'opened' : 'closed');

            // Get the answer text for content optimization
            const answerText = details.querySelector('.disclosure__content')?.textContent?.trim() || '';
            const productContext = getProductContext();

            if (window.posthog && typeof window.posthog.capture === 'function') {
              window.posthog.capture('faq_question_toggled', {
                question_text: questionText,
                question_answer: answerText,
                faq_section: sectionTitle,
                question_index: index + 1,
                action: isOpen ? 'opened' : 'closed',
                page_type: document.body.className.match(/template-(\w+)/)?.[1] || 'unknown',
                page_url: window.location.href,
                page_title: document.title,
                ...productContext
              });
            }
          } catch (error) {
            console.warn('FAQ toggle tracking failed:', error.message);
          }
        });
        
        // Track clicks on the summary (question header)
        summary.addEventListener('click', function() {
          try {
            console.log('FAQ clicked:', questionText);

            // Get the answer text for content optimization
            const answerText = details.querySelector('.disclosure__content')?.textContent?.trim() || '';
            const productContext = getProductContext();

            if (window.posthog && typeof window.posthog.capture === 'function') {
              window.posthog.capture('faq_question_clicked', {
                question_text: questionText,
                question_answer: answerText,
                faq_section: sectionTitle,
                question_index: index + 1,
                page_type: document.body.className.match(/template-(\w+)/)?.[1] || 'unknown',
                page_url: window.location.href,
                page_title: document.title,
                ...productContext
              });
            }
          } catch (error) {
            console.warn('FAQ click tracking failed:', error.message);
          }
        });
      });
    });
    
      console.log('SP FAQ tracking initialized for', faqSections.length, 'sections');
    } catch (error) {
      console.warn('SP FAQ tracking initialization failed:', error.message);
      // Don't track the error to avoid recursive issues
    }
  }
  
  // Initialize when DOM is ready and PostHog is available
  function start() {
    waitForPostHog(initFAQTracking);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();